import { useState } from "react";
import { School } from "lucide-react";

interface CollegeLogoProps {
  logoUrl: string | null | undefined;
  collegeName: string;
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

const sizeClasses = {
  sm: "h-16 w-16",
  md: "h-20 w-20", 
  lg: "h-24 w-24",
  xl: "h-28 w-28"
};

const iconSizes = {
  sm: "h-8 w-8",
  md: "h-10 w-10",
  lg: "h-12 w-12",
  xl: "h-14 w-14"
};

export function CollegeLogo({ logoUrl, collegeName, size = "lg", className = "" }: CollegeLogoProps) {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const showFallback = !logoUrl || imageError;
  const sizeClass = sizeClasses[size];
  const iconSize = iconSizes[size];

  return (
    <div className={`${sizeClass} flex-shrink-0 relative ${className}`}>
      {!showFallback && (
        <img
          src={logoUrl}
          alt={`${collegeName} logo`}
          className={`${sizeClass} object-contain rounded ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageError(true)}
        />
      )}
      {(showFallback || !imageLoaded) && (
        <div 
          className={`${sizeClass} bg-gray-100 rounded-full flex items-center justify-center ${!showFallback && !imageLoaded ? 'absolute inset-0' : ''}`}
        >
          <School className={`${iconSize} text-gray-400`} />
        </div>
      )}
    </div>
  );
}
